import React, { useState, useEffect } from 'react';
import refresh from '../assets/images/refresh.png';
const SimpleCaptcha = ({ onValidate }) => {
    const [question, setQuestion] = useState('');
    const [correctAnswer, setCorrectAnswer] = useState(null);
    const [userAnswer, setUserAnswer] = useState('');

   
    const generateQuestion = () => {
        const num1 = Math.floor(Math.random() * 31) + 10; //  num1 is between 10 and 40
        const num2 = Math.floor(Math.random() * (num1 - 1)) + 1; // num2 will be between 0 and num1
        const operations = ['+', '-'];
        const operation = operations[Math.floor(Math.random() * operations.length)];
    
        let expression = `${num1} ${operation} ${num2}`;
        let answer = eval(expression); // still safe for basic +/-
    
        setQuestion(expression);
        setCorrectAnswer(answer);
        setUserAnswer('');
        onValidate(false);
    };

    useEffect(() => {
        generateQuestion();
    }, []);

    const handleChange = (e) => {
        const value = e.target.value;
        setUserAnswer(value);
        const isCorrect = parseInt(value) === correctAnswer;
        onValidate(isCorrect);
    };

    const handleRefresh = () => {
        generateQuestion();
    };

    return (
        <div className="form-group captcha-wrapper mb-3">
            <div className="form-label ">
                <div className='d-block captcha-level'>Captcha </div>
                <div className='d-flex align-items-center justify-content-between'>
                    <div className='question-wrapper'>{question}</div>
                    <span className='d-inline-block ms-2 refresh-button' onClick={handleRefresh}>
                        <img alt="refresh" src={refresh}/>
                    </span>
                </div>
                
            </div>
            <input
                className="form-control"
                type="text"
                value={userAnswer}
                onChange={handleChange}
                placeholder="Enter your answer"
                autoComplete="off"
                required
            />
        </div>
    );
};

export default SimpleCaptcha;
